
import confetti from "canvas-confetti"

export const handleFireworksConfettiClick = ({ onBlastFinished }) => {
    const duration = 1 * 1000
    const animationEnd = Date.now() + duration
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 }
    const randomInRange = (min, max) =>
        Math.random() * (max - min) + min
    const interval = window.setInterval(() => {
        const timeLeft = animationEnd - Date.now()
        if (timeLeft <= 0) {
            return clearInterval(interval)
        }
        const particleCount = 50 * (timeLeft / duration)
        confetti({
            ...defaults,
            particleCount,
            origin: { x: 2, y: 2 },
        })
        confetti({
            ...defaults,
            particleCount,
            origin: { x: 2, y: 2 },
        })
    }, 350)
    setTimeout(() => {
        if (typeof onBlastFinished === "function") {
            onBlastFinished();
        }
    }, 2000);
};

export const handleFireworksConfettiClickForRapFire = ({ onBlastFinished }) => {
    const duration = 1 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 80, spread: 360, ticks: 800, zIndex: 1 };

    // Use GlobalOptions.resize to ensure confetti resizes with window
    if (confetti && confetti.GlobalOptions) {
        confetti.GlobalOptions.resize = true;
    }

    const interval = window.setInterval(() => {
        const timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) {
            return clearInterval(interval);
        }
        const particleCount = 1500 * (timeLeft / duration);

        confetti({
            ...defaults,
            particleCount,
            origin: { x: 0.6, y: 0.5 },
        });
    }, 500);
    setTimeout(() => {
        if (typeof onBlastFinished === "function") {
            onBlastFinished();
        }
    }, 2000);
};

export const handleCustomConfettiClick = ({ onBlastFinished, angle }) => {
    const scalar = 2
    const triangle = confetti.shapeFromPath({
        path: "M0 10 L5 0 L10 10z",
    })
    const square = confetti.shapeFromPath({
        path: "M0 0 L10 0 L10 10 L0 10 Z",
    })
    const coin = confetti.shapeFromPath({
        path: "M5 0 A5 5 0 1 0 5 10 A5 5 0 1 0 5 0 Z",
    })
    const tree = confetti.shapeFromPath({
        path: "M5 0 L10 10 L0 10 Z",
    })
    const defaults = {
        spread: angle || 180,
        ticks: 120,
        gravity: 1,
        decay: 0.98,
        startVelocity: 20,
        shapes: [triangle, square, coin, tree],
        scalar,
    }
    const shoot = () => {
        confetti({
            ...defaults,
            particleCount: 80,
        })
        confetti({
            ...defaults,
            particleCount: 50,
        })
        confetti({
            ...defaults,
            particleCount: 25,
            scalar: scalar / 2,
            shapes: ["circle"],
        })
    }
    setTimeout(shoot, 0)
    setTimeout(shoot, 100)
    setTimeout(shoot, 200)
    setTimeout(shoot, 300)
    //setTimeout(shoot, 400)

    // Call the callback after the last blast (adjust timing if needed)
    setTimeout(() => {
        if (typeof onBlastFinished === "function") {
            onBlastFinished();
        }
    }, 350);
}


export const handleCustomConfettiClick2 = ({ onBlastFinished, angle }) => {
    const scalar = 2
    const triangle = confetti.shapeFromPath({
        path: "M0 10 L5 0 L10 10z",
    })
    const square = confetti.shapeFromPath({
        path: "M0 0 L10 0 L10 10 L0 10 Z",
    })
    const coin = confetti.shapeFromPath({
        path: "M5 0 A5 5 0 1 0 5 10 A5 5 0 1 0 5 0 Z",
    })
    const tree = confetti.shapeFromPath({
        path: "M5 0 L10 10 L0 10 Z",
    })
    const defaults = {
        spread: angle || 180,
        ticks: 120,
        gravity: 1,
        decay: 0.98,
        startVelocity: 20,
        shapes: [triangle, square, coin, tree],
        scalar,
    }
    const shoot = () => {
        confetti({
            ...defaults,
            particleCount: 80,
        })
        confetti({
            ...defaults,
            particleCount: 50,
        })
        confetti({
            ...defaults,
            particleCount: 25,
            scalar: scalar / 2,
            // shapes: ["circle"],
        })
    }
    setTimeout(shoot, 0)
    setTimeout(shoot, 100)
    setTimeout(shoot, 200)
    setTimeout(shoot, 300)
    //setTimeout(shoot, 400)

    // Call the callback after the last blast (adjust timing if needed)
    setTimeout(() => {
        if (typeof onBlastFinished === "function") {
            onBlastFinished();
        }
    }, 350);
}